module.exports = __webpack_public_path__ + "static/media/address.b1413f49.png";